document.addEventListener('DOMContentLoaded', () => {
	
	// Sélectionne tous les éléments déclencheurs
	const launchers = document.querySelectorAll('[data-launcher]');

	// Boucle sur chaque déclencheur
	launchers.forEach(launcher => {
		launcher.addEventListener('click', () => {
			const videoId = launcher.getAttribute('data-launcher');

			// Recherche du <dialog> correspondant
			const targetDialog = document.querySelector(`dialog[data-video="${videoId}"]`);

			if (targetDialog) {
				if (typeof targetDialog.showModal === 'function') {
					targetDialog.showModal();
				} else {
					console.warn('Le navigateur ne supporte pas <dialog>.');
				}
			} else {
				console.log(`Aucun <dialog> trouvé avec data-video="${videoId}"`);
			}
		});
	});

	// Sélectionne tous les boutons de fermeture
	const closeButtons = document.querySelectorAll('.dialog-video__close');

	// Boucle sur chaque bouton de fermeture
	closeButtons.forEach(button => {
		button.addEventListener('click', () => {
			const dialog = button.closest('dialog');
			if (dialog) dialog.close();
		});
	});
	
});